import { Program } from "globals/store/programs.data"


 export const trackByProgram = (index, program: Program) => {
    return program.id
  }